import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Box, Button, CloseButton, Column, ProgressBar, Row, TextButton } from 'seagull';
import { ArrowLeft } from 'seagull/icons';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import styles from './OnboardingLayout.module.scss';
export const GetOnboardingLayoutTID = (parentTestId)=>getTestIds({
        parentTestId
    });
export const OnboardingLayout = (param)=>{
    let { testId, progress, children, onBack, onContinue, onSkip, onClose, continueLabel, skipLabel, showSkipButton = false, isContinueDisabled = false, isContinueLoading = false, isBackDisabled = false, isSkipDisabled = false } = param;
    const testIds = useMemo(()=>GetOnboardingLayoutTID(testId), [
        testId
    ]);
    const { t } = useLocaleKeys('pages.vendorOnboarding.onboardingLayout');
    return /*#__PURE__*/ _jsxs(Column, {
        className: styles.root,
        testId: testIds.OnboardingLayoutTestIds.Root(),
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: styles.header,
                children: [
                    onBack && /*#__PURE__*/ _jsx(TextButton, {
                        skin: "dark",
                        underline: "none",
                        prefixIcon: /*#__PURE__*/ _jsx(ArrowLeft, {}),
                        onClick: onBack,
                        disabled: isBackDisabled,
                        testId: testIds.OnboardingLayoutTestIds.BackButton()
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: styles.progressBarContainer,
                        children: /*#__PURE__*/ _jsx(ProgressBar, {
                            completed: progress,
                            total: 100,
                            variant: "steps",
                            className: styles.progressBar,
                            testId: testIds.OnboardingLayoutTestIds.ProgressBar()
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: styles.closeSlot,
                        children: onClose && /*#__PURE__*/ _jsx(CloseButton, {
                            size: "medium",
                            skin: "standard",
                            onClick: onClose,
                            bi: {
                                name: 'vendor_onboarding_close'
                            },
                            testId: testIds.OnboardingLayoutTestIds.CloseButton()
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Box, {
                className: styles.content,
                testId: testIds.OnboardingLayoutTestIds.Content(),
                children: children
            }),
            /*#__PURE__*/ _jsxs(Row, {
                className: styles.footer,
                alignItems: "center",
                justifyContent: "center",
                gap: 24,
                children: [
                    showSkipButton && onSkip && /*#__PURE__*/ _jsx(TextButton, {
                        onClick: onSkip,
                        underline: "none",
                        disabled: isSkipDisabled,
                        testId: testIds.OnboardingLayoutTestIds.SkipButton(),
                        children: skipLabel !== null && skipLabel !== void 0 ? skipLabel : t.skip()
                    }),
                    onContinue && /*#__PURE__*/ _jsx(Button, {
                        bi: {
                            name: 'onboarding_continue'
                        },
                        skin: "primary",
                        onClick: onContinue,
                        disabled: isContinueDisabled || isContinueLoading,
                        loading: isContinueLoading,
                        className: styles.continueButton,
                        testId: testIds.OnboardingLayoutTestIds.ContinueButton(),
                        children: continueLabel !== null && continueLabel !== void 0 ? continueLabel : t.continue()
                    })
                ]
            })
        ]
    });
};
